require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-rates-health-savings-account-rates.json") })
        }
      }, "path---es-rates-health-savings-account-rates");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-rates-health-savings-account-rates!./.cache/json/es-rates-health-savings-account-rates.json
// module id = 2607
// module chunks = 231608221292675